import { isArray } from '@razlet/utils';
import TariffProduct from '../tariff-product';
import {
  calculateDimensionVolume,
  DIMENSION_VOLUME_PRECISION,
  resolveVolumePrecision,
  roundVolume,
} from '~/utils/volume';

export default class ShipmentCargo {
  pieces = null;
  weight = null;
  volume = null;

  constructor (data) {
    if (!data) return;
    const precision = resolveVolumePrecision({ company: data.company });
    if (data.cargo) {
      this.pieces = data.cargo.pieces;
      this.weight = data.cargo.weight;
      this.volume = roundVolume(data.cargo.volume, precision);
    }
    this.commodity = {
      name: data.commodity,
      code: data.commodityCode,
    };
    this.charge = {
      weight: data.chargeWeight,
      explain: data.chargeWeightExplain,
    };
    this.product = data.tariffProduct ? new TariffProduct(data.tariffProduct) : {};
    this.dimensions = (isArray(data.dimensions) ? data.dimensions : []).map(item => {
      return {
        ...item,
        volume: roundVolume(calculateDimensionVolume(item), DIMENSION_VOLUME_PRECISION)
          .toFixed(DIMENSION_VOLUME_PRECISION),
      };
    });
    this.shc = isArray(data.shcList) ? data.shcList : [];
    this.hs = isArray(data.hsList) ? data.hsList : [];
    this.additional = {
      specialRequest: data.ssr || '',
      otherInfo: data.osi || '',
      notify: data.notify || '',
    };
  }

  get isAdditional () {
    if (!this.additional) return null;
    return this.additional.specialRequest.length > 1 ||
           this.additional.otherInfo.length > 1 ||
           this.additional.notify.length > 1;
  }

  get fullName () {
    return `${this.pieces}/${this.weight}/${this.volume}`;
  }
};
